import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import Swal from "sweetalert2";
import { FaFastBackward } from "react-icons/fa";
const EmpDataCount = () => {
  const [DistrictsPayBillActualData, setDistrictsPayBillActualData] = useState(
    []
  );
  const history = useHistory();
  const [editableRows, setEditableRows] = useState({});
  const [anyCheckboxSelected, setAnyCheckboxSelected] = useState(false);
  const [DistrictsPayBillData, setDistrictsPayBillData] = useState([]);
  React.useEffect(() => {
    HousingService.DistrictsPayBill().then((res) => {
      console.log("res.data[0].Actual", res.data[0].Actual);
      setDistrictsPayBillData(res.data);
      setDistrictsPayBillActualData(res.data[0].Actual);
    });
    console.log("DistrictsPayBill[0]", DistrictsPayBillActualData);
  }, []);

  const handleDataUpdate = async (i, field, value) => {
    try {
      const updatedDistrictsPayBillActualData = [...DistrictsPayBillActualData];
      updatedDistrictsPayBillActualData[i][field] = value;

      setDistrictsPayBillActualData(updatedDistrictsPayBillActualData);
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };
  const handleUpdate = async () => {
    if (!anyCheckboxSelected) {
      showNotification(
        "warning",
        "Please select at least one checkbox before updating."
      );
      return; // Exit the function if no checkboxes are selected
    }
    console.log("DistrictsPayBillData", DistrictsPayBillActualData);

    const updatedDistrictsPayBillDataData = DistrictsPayBillActualData.map(
      (actualItem, i) => ({
        code: actualItem.code,
        reg_apshcl: actualItem.reg_apshcl,
        reg_deputation: actualItem.reg_deputation,
        outsourcing: actualItem.asoutsourcing,
        nmr: actualItem.nmr
      })
    ).filter((actualItem, i) => editableRows[i]);
    console.log(
      "updatedDistrictsPayBillDataData",
      updatedDistrictsPayBillDataData
    );
    Swal.fire({
      text: "Are You Sure Want to Update?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const responseDistrictsPayBillData =
          await HousingService.UpdateDistrictsPayBillCount(
            updatedDistrictsPayBillDataData
          );

        if (responseDistrictsPayBillData?.data?.SCODE === "01") {
          showNotification("success", "Submitted successfully By GMF");
          HousingService.DistrictsPayBill().then((res) => {
            console.log("res.data[0].Actual", res.data[0].Actual);
            setDistrictsPayBillActualData(res.data);
          });
        } else {
          showNotification("error", "Having as Error");
        }
      }
    });
  };
  return (
    <div>
      {" "}
      <NavigationServicesHeader />
      <OFMSUI.Container>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <div className="inner-herbpage-service-title1">
              <h1 style={{ marginLeft: "-15px" }}>DISTRICTS PAYBILL</h1>
            </div>
          </OFMSUI.Col>

          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <button
              className="btn btn-primary btn-sm"
                style={{ textAlign: "right", float: "right", marginTop: "30px",backgroundColor: "#603913",borderColor: "#603913", color: "#fff"
              }}
              type="reset"
              onClick={() => history.goBack()}
            >
              <FaFastBackward /> &nbsp;Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container ">
        <OFMSUI.Table striped bordered hover id="my-table">
          <thead className="fw-bold">
            <tr class="table_countshead">
              <th>S No.</th>
              <th> District Name</th>
              <th colSpan={2} style={{ textAlign: "center" }}>
                {" "}
                APSHCL Regular
              </th>
              <th colSpan={2} style={{ textAlign: "center" }}>
                APSHCL Deputation
              </th>
              <th colSpan={2} style={{ textAlign: "center" }}>
                OutSourcing
              </th>
              <th colSpan={2} style={{ textAlign: "center" }}>
                NMR/Min. Emoluments
              </th>
              <th colSpan={2} style={{ textAlign: "center" }}>
                Total
              </th>
              <th> Select</th>
            </tr>
            <tr class="table_countshead">
              <th></th>
              <th></th>
              <th> Actual</th>
              <th> Entered </th>
              <th> Actual</th>
              <th> Entered </th>
              <th> Actual</th>
              <th> Entered </th>
              <th> Actual</th>
              <th> Entered </th>
              <th> Actual</th>
              <th> Entered </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {DistrictsPayBillActualData.map((actualItem, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                {DistrictsPayBillData[0]?.Entered[i] && (
                  <td>{DistrictsPayBillData[0].Entered[i].name}</td>
                )}

                <td>
                  {editableRows[i] ? (
                    <input
                      type="text"
                      style={{ width: "50px" }}
                      defaultValue={actualItem.reg_apshcl}
                      onChange={(e) =>
                        handleDataUpdate(i, "reg_apshcl", e.target.value)
                      }
                    />
                  ) : (
                    actualItem.reg_apshcl
                  )}
                </td>
                {DistrictsPayBillData[0]?.Entered[i] && (
                  <td>{DistrictsPayBillData[0].Entered[i].regular}</td>
                )}
                <td>
                  {editableRows[i] ? (
                    <input
                      type="text"
                      style={{ width: "50px" }}
                      defaultValue={actualItem.reg_deputation}
                      onChange={(e) =>
                        handleDataUpdate(i, "reg_deputation", e.target.value)
                      }
                    />
                  ) : (
                    actualItem.reg_deputation
                  )}
                </td>

                {DistrictsPayBillData[0]?.Entered[i] && (
                  <td>{DistrictsPayBillData[0].Entered[i].deputation}</td>
                )}
                <td>
                  {editableRows[i] ? (
                    <input
                      type="text"
                      style={{ width: "50px" }}
                      defaultValue={actualItem.asoutsourcing}
                      onChange={(e) =>
                        handleDataUpdate(i, "asoutsourcing", e.target.value)
                      }
                    />
                  ) : (
                    actualItem.asoutsourcing
                  )}
                </td>

                {DistrictsPayBillData[0]?.Entered[i] && (
                  <td>{DistrictsPayBillData[0].Entered[i].os}</td>
                )}
                <td>
                  {editableRows[i] ? (
                    <input
                      type="text"
                      style={{ width: "50px" }}
                      defaultValue={actualItem.nmr}
                      onChange={(e) =>
                        handleDataUpdate(i, "nmr", e.target.value)
                      }
                    />
                  ) : (
                    actualItem.nmr
                  )}
                </td>

                {DistrictsPayBillData[0]?.Entered[i] && (
                  <td>{DistrictsPayBillData[0].Entered[i].nmr}</td>
                )}
                <td>{actualItem.total}</td>
                {DistrictsPayBillData[0]?.Entered[i] && (
                  <td>{DistrictsPayBillData[0].Entered[i].total}</td>
                )}
                <td>
                  <input
                    type="checkbox"
                    onClick={() => {
                      setEditableRows((prevEditableRows) => ({
                        ...prevEditableRows,
                        [i]: !prevEditableRows[i]
                      }));
                      setAnyCheckboxSelected(true);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </OFMSUI.Table>
        <center>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
            {" "}
            <button
              className="btn btn-success btn-sm"
              type="submit"
              style={{ marginTop: "30px" }}
            >
              Update
            </button>
          </OFMSUI.Col>
        </center>
      </OFMSUI.Container>

    </div>
  );
};

export default EmpDataCount;
